import * as fromDatatype from '../datatype-library/index';
import {bl_fi_mst_shipping_price_book_event_RowInterface} from "./bl_fi_mst_shipping_price_book_event.model";

export interface bl_fi_mst_shipping_price_book_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_shipping_price_book_hdr_RowClass
  implements bl_fi_mst_shipping_price_book_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
